<template>
  <div>
    <v-form @submit.prevent="login" ref="form">
        <div v-if="redirecturl && appId">
          <div class="card pa-[40px]"> 
            <div class="Login-title pa-0  mt-3" align="center">Login to Your Account</div>
              
            <v-error class="error  d-flex justify-center text-center pa-0 ma-0 pt-2"   style="min-height: 24px;" v-show="true">
          <span v-if="error">Invalid Username And Password</span>
          </v-error>
            <div class="pa-0 mt-4 mb-0">
              <v-text-field
                v-model="email"
                type="email"
                placeholder="Your Email"
                prepend-inner-icon="mdi mdi-email"
                variant="outlined"
                density="compact"
                :rules="[rules.userRule, rules.emailValidation]"
                class="custom-text-field"
                hide-details="auto"
              />
            </div>
            <div class="pa-0 mt-2 mb-0">
              <v-text-field
                density="compact"
                hide-details="auto"
                @click:append-inner="showPassword = !showPassword"
                prepend-inner-icon="mdi mdi-lock"
                placeholder="Your Password"
                :rules="passwordRule"
                v-model="password"
                variant="outlined"
                v-bind:type="[showPassword ? 'text' : 'password']"
                :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                 class="custom-text-field"
              />
            </div>
            <div class="pa-0"  align="center">
              <p style="color: red">{{ message }}</p>
            </div>
            <div class="d-flex justify-space-between align-center">
              <v-checkbox
              v-model="rememberMe"
              label="Remember me"
              density="compact"
               class="pa-0 ma-0 checkbox-remember"
              hide-details
             ></v-checkbox>
              <v-btn variant="text" class="forget pa-0" to="/forgetpassword"  style="font-size: 11px; font-family: Poppins;"
                >Forget Password ?</v-btn
              >
            </div>

            <div class="pa-0 mt-10"  align="center">
              <v-btn
                block
                color="#1b1a47"
                type="submit"
                size="large"
                :disabled="loading"
                :loading="loading"
                class="text-none mb-4 text-white log-btn"
                >Sign In</v-btn
              >
            </div>
            <div class="pa-0 log-text" >
              <p>If you have trouble signing in,</p>
               please contact the support team. By <a href="" class="link">clicking here!</a>
            </div>
          </div>
        </div>
        <div v-else>
          &nbsp;
          <v-img style="margin: 0 auto" width="100px"></v-img>
          <div class="text-red" style="font-weight: 700"
            >Request did not originate from an Authorized domain!</div
          >
        </div>
      </v-form>
  </div>
</template>

<script>
import userService from "../api/service/UserService.js";
import { authStore } from "@/store";
import DynamodbModel from "@/api/service/Dynamodb/DynamodbService";

export default {
  components: {
  },
  data() {
    return {
      loading: false,
      error: false,
      host: window.location.host,
      message: null,
      redirecturl: null,
      showPassword: false,
      password: "",
      emailValidation: "",
      rememberMe:false,
      passwordRule: [(value) => !!value || "Password is Required."],
      email: "",
      rules: {
        userRule: (value) => !!value || "Email is Required.",
      },
    };
  },
  created() {
    if (this.$route.query.appId) {
      let data = {
        appId: this.$route.query.appId,
        sessionId: this.$route.query.sessionId,
        redirectUrl: this.$route.query.redirectUrl,
      };
      localStorage.setItem("APP_ID", this.$route.query.appId);
      localStorage.setItem("login_details", JSON.stringify(data));
    }
    let $data = JSON.parse(localStorage.getItem("login_details"));
    console.log($data, "datatata");

    this.redirecturl = $data.redirectUrl;
    localStorage.setItem("REDIRECT_URL", this.redirecturl);
    this.appId = $data.appId;

    this.getAppDetail();
  },
  computed: {
    appDetail() {
      return authStore.getters.getAppDetail;
    },
  },
  methods: {
    async getAppDetail() {
      if (this.$route.query.appId) {
        let res = await DynamodbModel.AppDetails(this.$route.query.appId);
        console.log(res, "hlo");
        authStore.commit("setAppDetail", res);
        this.loading = false;
      } else {
        this.loading = false;
      }
    },
    async login() {
      if (this.email && this.password) {
        try {
          this.loading = true;
          let response = await userService.fireBaseLogin({
            email: this.email,
            password: this.password,
            appId: this.$route.query.appId,
          });

          if (response.data.token) {
            try {
              this.$router.push({
               path:'/otp',
               query:{
                 token:response.data.token,
                 mail:this.email
               }
              })

              // window.location = "http://localhost:8080"+"/otp"+ "?token=" + response.data.token;
              // window.location = this.redirecturl + "?token=" + response.data.token;
            } catch (e) {
              this.error = true;
              this.loading = false;
              console.log(e);
            }
          }
        } catch (e) {
          this.error = true;
          this.loading = false;
        }
      }
    },
  },
};
</script>
<style scoped>
.link{
  cursor: pointer;
  color: #317FFF; 
  font-weight: 600;
   text-decoration: underline;
}

>>>.v-field--error:not(.v-field--disabled) .v-field__prepend-inner > .v-icon, .v-field--error:not(.v-field--disabled) .v-field__append-inner > .v-icon, .v-field--error:not(.v-field--disabled) .v-field__clearable > .v-icon {
    color: #5e5f60 !important;
}

>>>.v-field--error:not(.v-field--disabled) .v-field__append-inner > .v-icon, .v-field--error:not(.v-field--disabled) .v-field__append-inner > .v-icon, .v-field--error:not(.v-field--disabled) .v-field__clearable > .v-icon {
    color: #5e5f60 !important;
}
</style>
